import React from "react";
import classnames from "classnames";
import { GalleryHeader } from "../partials/GalleryHeader";
import { GalleryFooter } from "../partials/GalleryFooter";

import "./Page.css";

type PageProps = { scrollable?: boolean; disableThumbnails?: boolean } & React.ComponentProps<"div">;

function Page(props: PageProps) {
  const { children: content, scrollable, disableThumbnails, className, ...rest } = props;
  const classNames = classnames("page__container", {
    "page__container--no-scroll": props.scrollable === false,
  });

  return (
    <div className={classNames} {...rest}>
      <div className="page__header">
        <GalleryHeader />
      </div>
      <PageContent scrollable={scrollable}>{content}</PageContent>
      <div className="page__footer">
        <GalleryFooter disableThumbnails={disableThumbnails} />
      </div>
    </div>
  );
}

export function PageContent(props: PageProps) {
  const classNames = classnames("page__content", {
    "page__content--no-scroll": props.scrollable === false,
  });

  return <div className={classNames}>
    {props.children}
  </div>;
}

export default Page;
